import { envConfig } from '@env/config';

export default function getSearchEngineUrl() {
  return envConfig.NEXT_PUBLIC_SEARCH_ENGINE_URL;
}
